import React from "react";
import './enterpriseIcon.scss';

const EnterpriseIcon = (props) => {
    return (
        <div className={`enterprise-icon-wrap ${props.className}`} style={{ width: props.width || '56px', height: props.width || '56px' }}>
            <i className="iconfont icon-qiye" style={{ fontSize: props.size || '30px'  }}></i>
        </div>
    )
}
export default EnterpriseIcon;